import axios from 'axios';
import pako from "pako";
export default {
    getBaseURL: function () {
        return (process.env.NODE_ENV == "development" ? "http://127.0.0.1:3344" : "https://dy-sh.deli7788.cn");
    },
    getUserInfo: function () {
        var s = localStorage.getItem("user-info");
        if (s) {
            return JSON.parse(s);
        }
        return;
    },
    getService: function () {
        let baseUrl = this.getBaseURL();
        // console.log("baseUrl",baseUrl);
        // console.log("window.require",window.require);
        return axios.create({
            baseURL: baseUrl, // api的base_url
            timeout: 600000,                 // 请求超时时间
            withCredentials: true,		//携带cookie
            headers: { 'x-Requested-With': 'xmlhttprequest' }, //ajax请求
        });
    },
    postGzip: function (url, parameter, headers) {
        var user = this.getUserInfo();
        if (headers === undefined) {
            headers = {};
        }
        if (user) {
            headers.Token = user.mtk;
            headers.SToken = user.stk;
        }
        headers["Content-Type"] = "application/json";
        headers["Content-Encoding"] = "gzip";
        headers["Accept-Encoding"]="gzip, deflate, br";
        user = null;
        const jsonStr = typeof parameter === "string" ? parameter : JSON.stringify(parameter);
        return this.getService()({
            url: url,
            method: 'post',
            data: pako.gzip(jsonStr),
            headers: headers
        }).then(rs => {
            if (rs.status == 200) {
                return rs.data;
            } else {
                return { code: -1, err: "请求数据异常" }
            }
        }).catch(() => {
            return { code: -1, err: "请求数据异常" }
        })
    },
    post: function (url, parameter, headers) {
        var user = this.getUserInfo();
        if (headers === undefined) {
            headers = {};
        }
        if (user) {
            headers.Token = user.mtk;
            headers.SToken = user.stk;
        }
        headers["Accept-Encoding"]="gzip, deflate, br";
        user = null;
        return this.getService()({
            url: url,
            method: 'post',
            data: parameter,
            headers: headers
        }).then(rs => {
            if (rs.status == 200) {
                return rs.data;
            } else {
                return { code: -1, err: "请求数据异常" }
            }
        }).catch(() => {
            return { code: -1, err: "请求数据异常" }
        })
    }
}